export default "__VITE_ASSET__AzM40WSo__"